import apiHandler from "../core/apiHandler";

const itemTypeApi = apiHandler('item-types');
export default itemTypeApi;